import { useMutation } from "@tanstack/react-query";
import { apiV1Endpoint } from "../../../../../../api/v1";
import { ApiResponse } from "../../../../../../types/api-response";
import axios from "../../../../../../utils/axiosInceptor";

export type RejectBankTransferRequest = {
  leaseId: string;
  data: {
    pdcId: string;
  };
};

export type RejectBankTransferResponse = {
  message: string;
};

const rejectBankTransferRequest = async (payload: RejectBankTransferRequest) => {
  const { leaseId, data } = payload;

  const url = `${apiV1Endpoint}/booking/bank-transfer/reject/${leaseId}`;

  const response = await axios.patch<ApiResponse>(url, data);
  return response.data.result;
};

type UseRejectBankTransferOptions = {
  onSuccess?: (data: RejectBankTransferResponse) => void;
  onError?: (error: unknown) => void;
};

export const useRejectBankTransfer = (options: UseRejectBankTransferOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, isPending } = useMutation({
    mutationFn: rejectBankTransferRequest,
    onSuccess,
    onError,
  });

  return {
    rejectBankTransferRequest: mutateAsync,
    isPendingRejectBankTransfer: isPending,
  };
};
